module.exports = __webpack_public_path__ + "img/vdr-top3.95cd3197.png";